import { useQuery, UseQueryResult } from "@tanstack/react-query";
import {
  fetchSportsBookJWT,
  SportsBookJWTResponse,
} from "../features/sportsbook/fetchJWT";

export const useGetJWTSportsBookData = (): UseQueryResult<
  SportsBookJWTResponse,
  Error
> => {
  return useQuery<SportsBookJWTResponse, Error>({
    queryKey: ["sportsbook-jwt"],
    queryFn: fetchSportsBookJWT,
    enabled: true,
    refetchOnMount: true,
    retry: false,
  });
};
